// actionTypes.js

export const FETCH_DAILY_CHECKINOUTS_MADINA = 'FETCH_DAILY_CHECKINOUTS_MADINA';
export const FETCH_DAILY_CHECKINOUTS_MAKKAH = 'FETCH_DAILY_CHECKINOUTS_MAKKAH';
